/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import _ from 'lodash';
import {
  setPlanType,
  setRebateProgram,
  getRebateProgramCodePRT,
  sysReminderSetupList,
  dispatchMailedDateErrorMsg,
} from '../store/actions';
import { isNumeric } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { PLAN_TYPE_DATA, defaultTaskTypeValue } from './ConstantData';

const MailedDate = (props) => {
  const dispatch = useDispatch();
  const [curIndex, setCurIndex] = useState();
  const reminder_list = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.reminder_list
  );
  const getInputValue = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.getInputValue;
  });
  const userDefaults = useSelector(
      (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
    );
  const [reminderList, setReminderList] = useState();
  const defaultPlanType = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  console.log("ss",defaultRebateCd)
  const planType = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.planType
  );
  const rebateProgram = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.rebateProgram
  );
  const rebateDropdownData = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.rebate_list
  );
  const getMailedDateErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgMailedDate;
  });
  const newReminderPayload = {
    reminderName: '',
    rebateProgramCd: '',
    daysSinceInvPrinted: '',
  };
  // dispatch rebate program
  const dispatchRebateProgram = useCallback(
    (value) => {
      dispatch(setRebateProgram(value));
    },
    [rebateProgram]
  );
  // dispatch default plan type
  const dispatchPlanType = useCallback(
    (value) => {
      dispatch(setPlanType(value));
    },
    [planType]
  );

React.useEffect(() => {
  if (userDefaults && _.isEmpty(reminderList)) {
  
    if (!rebateProgram && userDefaults?.rebateProgramCd) {
      dispatchRebateProgram(userDefaults.rebateProgramCd);
    }
    setReminderList({
      reminderName: '',
      rebateProgramCd: userDefaults?.rebateProgramCd || '-1',
      daysSinceInvPrinted: '',
    });
  }
}, [userDefaults]);

  // dispatch default plan type
  React.useEffect(() => {
    if (!planType && defaultPlanType) {
      dispatchPlanType(defaultPlanType);
    } else if (!planType && (!defaultPlanType || defaultPlanType != -1)) {
      dispatchPlanType('FD');
    }
  }, [defaultPlanType]);
  // get reminder list data and assign to the state
  React.useEffect(() => {
    if (reminder_list && reminder_list.length != 0 && curIndex) {
      setReminderList({
        reminderName: reminder_list[curIndex - 1]?.reminderName || '',
        rebateProgramCd: reminder_list[curIndex - 1]?.rebateProgramCd || userDefaults?.rebateProgramCd,
        daysSinceInvPrinted:
          reminder_list[curIndex - 1]?.daysSinceInvPrinted || '',
      });
    } else if (reminder_list && reminder_list.length === 0) {
      setReminderList(newReminderPayload);
    }
  }, [reminder_list, curIndex]);
  // get InputValue from Redux and assign to the state
  React.useEffect(() => {
    const inputValue = isNumeric(getInputValue);
    if (inputValue && getInputValue) {
      setCurIndex(parseInt(getInputValue));
    } else {
      setCurIndex(getInputValue);
    }
  }, [getInputValue]);
  // dispatch plan type
  React.useEffect(() => {
    if (planType) dispatch(getRebateProgramCodePRT(planType));
    if (planType !== defaultPlanType) dispatchRebateProgram(null);
    else dispatchRebateProgram(defaultRebateCd);
  }, [planType]);
  // handle OnBlur reminder list text fields
  const handleOnBlur = (e) => {
    const type = e.target.name;
    const { value } = e.target;
    let localErr = getMailedDateErrorMsg || [];
      if (reminderList?.rebateProgramCd === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'reminderList?.rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateReq',
          message: 'Rebate Program is Required.',
        });
      } else {
        localErr = localErr?.filter((item) => item.field !== 'reminderList?.rebateProgramCd');
      }
    
    if (type === 'daysSinceInvPrinted') {
      if (value) {
        const rx = /^[0-9]{0,3}?$/;
        if (checkNumberValidation(rx, value)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
          localErr.push({
            field: 'daysSinceInvPrinted',
            errorType: 'daysSinceInvReq',
            message: `Item ${value} does not pass the validation test.`,
          });
        }
      } else if (!value) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
        localErr.push({
          field: 'daysSinceInvPrinted',
          errorType: 'daysSinceInvReq',
          message:
            'Item Days since Invoice Printed did not pass the validation test.',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchMailedDateErrorMsg(unique));
  };
  // check number validation
  const checkNumberValidation = (rx, amountVal) => {
    let val = false;
    if (rx.test(amountVal?.toString()?.replace('-', '').trim())) {
      val = true;
    }
    return val;
  };
  // on change reminder list text fields
  const handleChange = (e) => {
    if (reminder_list?.length > 0) {
      reminder_list[curIndex - 1][e.target.name] = e.target.value;
      reminder_list[curIndex - 1].addEditRow = true;

      setReminderList({
        ...reminderList,
        [e.target.name]: e.target.value,
      });
      dispatch(sysReminderSetupList(reminder_list));
      props.setDisableSaveCancel(true);
    } else {
      props.setDisableSaveCancel(false);
    }
  };
  useEffect(() => {
  if (
    rebateDropdownData?.length > 0 &&
    userDefaults?.rebateProgramCd
  ) {
    const exists = rebateDropdownData.some(
      item => item.value === userDefaults.rebateProgramCd
    );

    setReminderList(prev => ({
      ...prev,
      rebateProgramCd: exists
        ? userDefaults.rebateProgramCd
        : '-1',
    }));
  }
}, [rebateDropdownData, userDefaults]);

  return (
    <div data-testid="mailedDate-component">
      <div className="row mb-2">
        <div className="col-8">
          <fieldset className="custom-fieldset h-100">
            <legend className="same-font-family">
              Plan Type<span className="mandatory">*</span>
            </legend>
            <div className="sub-radio no-margin ">
              <FormControl>
                <RadioGroup
                  row
                  name="acc-plan-row-radio-buttons-group"
                  defaultValue={defaultPlanType || defaultTaskTypeValue}
                  value={planType || defaultTaskTypeValue}
                >
                  {PLAN_TYPE_DATA && !_.isEmpty(PLAN_TYPE_DATA)
                    ? PLAN_TYPE_DATA.map((v, i) => (
                        <FormControlLabel
                          value={v.value}
                          control={
                            <Radio
                              onChange={(e) => dispatchPlanType(v.value)}
                            />
                          }
                          label={v.name}
                          key={v.value && _.kebabCase(v.value)}
                          data-testid="radio-box-change-control"
                        />
                      ))
                    : null}
                </RadioGroup>
              </FormControl>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Rebate Program<span className="mandatory">*</span>
            </legend>
            <div className="form-wrapper p-0 h-100">
              <div className="mui-custom-form with-select field-xl no-lbl d-flex align-items-center">
                <TextField
                  label="Rebate Program"
                  fullWidth
                  select
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    id: 'rebateProgramCd',
                    'aria-label': 'rebateProgramCd',
                  }}
                  onChange={handleChange}
                  id="rebateProgramCd"
                  name="rebateProgramCd"
                  value={reminderList?.rebateProgramCd || '-1'}
                     helperText={
                    getMailedDateErrorMsg?.length > 0
                      ? _.map(getMailedDateErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getMailedDateErrorMsg?.length > 0
                      ? _.map(getMailedDateErrorMsg, (l) =>
                          l.field == 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value={
                      reminderList && reminderList.rebateProgramCd
                        ? reminderList.rebateProgramCd
                        : null
                    }
                    className="frr-dropdown-blank-item"
                  />
                  {rebateDropdownData?.length > 0
                    ? rebateDropdownData?.map((item) => {
                        return (
                          <MenuItem key={item.value} value={item.value}>
                            {`${item.label}`}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-4">
          <div className="form-wrapper p-0 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Reminder Description"
                  fullWidth
                  data-testid="reminderName"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 255,
                    id: 'reminderName',
                    'aria-label': 'reminderName',
                  }}
                  name="reminderName"
                  onChange={handleChange}
                  value={reminderList?.reminderName || ''}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="form-wrapper p-0 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Days since Invoice printed"
                  fullWidth
                  required
                  data-testid="days-sinceinv-printed"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxlength: 4,
                    'aria-label': 'daysSinceInvPrinted',
                  }}
                  name="daysSinceInvPrinted"
                  value={reminderList?.daysSinceInvPrinted || ''}
                  onChange={handleChange}
                  onBlur={handleOnBlur}
                  helperText={
                    getMailedDateErrorMsg?.length > 0
                      ? _.map(getMailedDateErrorMsg, (l) =>
                          l.field === 'daysSinceInvPrinted' ? l.message : null
                        )
                      : null
                  }
                  className={
                    getMailedDateErrorMsg?.length > 0
                      ? _.map(getMailedDateErrorMsg, (l) =>
                          l.field == 'daysSinceInvPrinted'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  error={
                    getMailedDateErrorMsg?.length > 0
                      ? _.map(getMailedDateErrorMsg, (l) =>
                          l.field == 'daysSinceInvPrinted' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MailedDate;
